import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { SplitService } from '../services/split/split.service';

@Injectable({
  providedIn: 'root',
})
export class SplitGuard implements CanActivate {
  constructor(private splitService: SplitService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Get the split name from route data, defaulting to 'request' if not specified
    const splitName = route.data['splitName'];

    return this.splitService.isOn(splitName);
  }
}
